export const logout = (navigate) => {
  localStorage.clear();
  sessionStorage.clear();
  navigate("/");
  window.location.reload();
};

export const checkAuth = () => {
  const token = localStorage.getItem("info");
  return !!token;
};
